import React, { Component } from 'react';
import Switch from 'react-switch';
import * as PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Button } from 'react-bootstrap';
import * as pages from '../../constants/pages';
import { UNITY_MODE_WEBGL, UNITY_MODE_CONSOLE } from '../../constants/unity';
import './Start.sass';
import logo from '../../img/wb-logo.svg';
import { faDoorOpen } from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class Start extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reloading: false,
    };
  }

  renderAppTitle = () => {
    let name = this.props.appName;
    if (name.length === 0) {
      return (
        <h1 key="loading">
          <img src={process.env.PUBLIC_URL + '/img/wbl_logo_box.png'} alt="WhiteBox Learning" width="72" height="72" />
          <em>Loading...</em>
        </h1>
      );
    }

    return (
      <h1 key="ready">
        <img
          src={process.env.PUBLIC_URL + '/img/wbl_logo_box.png'}
          alt="WhiteBox Learning"
          width="72"
          height="72"
          style={{ marginTop: 5 }}
        />
        <span>{name}</span>
      </h1>
    );
  };

  renderHello = () => {
    if (this.props.loading === true) {
      return null;
    }

    let text;
    if (this.props.studentAlias.length > 0) {
      text = <span>{'Hello, ' + this.props.studentAlias}</span>;
    } else {
      text = <span>Hello</span>;
    }
    return <div className="welcome-name">{text}</div>;
  };

  render() {
    let startClasses = 'start-button';
    if (this.props.loading) {
      startClasses += ' loading';
    }

    return (
      <div className="welcome">
        <TransitionGroup component={null}>
          <CSSTransition
            key="hello"
            classNames="fade"
            timeout={{ enter: 1000, exit: 100 }}
          >
            {this.renderHello()}
          </CSSTransition>
          <CSSTransition
            key="logout"
            classNames="fade"
            timeout={{ enter: 1000, exit: 100 }}
          >
            <div className="welcome-logout">
              <a href="#" onClick={this.props.resetApp}>
                Back to App Selection
              </a>{' '}
              |&nbsp;
              <a href="#logout" onClick={this.props.logout}>
                Sign Out <i className="fa fa-sign-out" />
              </a>
            </div>
          </CSSTransition>
          <CSSTransition
            key="title"
            classNames="fade"
            timeout={{ enter: 300, exit: 100 }}
          >
            <div className="welcome-title">{this.renderAppTitle()}</div>
          </CSSTransition>
        </TransitionGroup>
        <div className="welcome-body">
          <div className="welcome-hero">
            <Button
              disabled={this.props.loading}
              onClick={() => this.props.gotoPage(pages.PAGE_RESEARCH)}
              key="research"
              className={startClasses}
            >
              Start
            </Button>
          </div>
          <div className="welcome-buttons">
            <Button
              disabled={this.props.loading}
              onClick={() => this.props.gotoPage(pages.PAGE_RESEARCH)}
              className="btn-block"
              size="large"
              id="start-research"
            >
              <span className="num">1</span>
              <span className="name">Research</span>
            </Button>
            <Button
              disabled={this.props.loading}
              onClick={() => this.props.gotoPage(pages.PAGE_ENGINEERING)}
              className="btn-block"
              size="large"
            >
              <span className="num">2</span>
              <span className="name">Engineering</span>
            </Button>
            <Button
              disabled={this.props.loading}
              onClick={() => this.props.gotoPage(pages.PAGE_SIMULATION)}
              className="btn-block"
              size="large"
            >
              <span className="num">3</span>
              <span className="name">Competition</span>
            </Button>
            <Button
              disabled={this.props.loading}
              onClick={() => this.props.gotoPage(pages.PAGE_OUTPUTS)}
              className="btn-block"
              size="large"
            >
              <span className="num">4</span>
              <span className="name">Outputs</span>
            </Button>
            <Button
              disabled={this.props.loading}
              onClick={() => this.props.gotoPage(pages.PAGE_BUILD)}
              className="btn-block"
              size="large"
            >
              <span className="num">5</span>
              <span className="name">Build & Test</span>
            </Button>
          </div>
        </div>
        <div className="text-center mt-4">
          <Button onClick={this.props.startTour} size="lg" variant="primary">
            <FontAwesomeIcon icon={faDoorOpen} /> Take a Tour
          </Button>
          <br />
        </div>

        {/* {process.env.NODE_ENV === 'development' && ( */}
        {/*   <div className="unity-mode"> */}
        {/*     <label style={{ display: 'flex', alignItems: 'center' }}> */}
        {/*       <Switch */}
        {/*         height={20} */}
        {/*         width={40} */}
        {/*         checked={this.props.unityMode === UNITY_MODE_CONSOLE} */}
        {/*         onChange={() => { */}
        {/*           this.props.setUnityMode( */}
        {/*             this.props.unityMode === UNITY_MODE_CONSOLE */}
        {/*               ? UNITY_MODE_WEBGL */}
        {/*               : UNITY_MODE_CONSOLE */}
        {/*           ); */}
        {/*         }} */}
        {/*       /> */}
        {/*       <span style={{ marginLeft: '10px' }}>Unity Console</span> */}
        {/*     </label> */}
        {/*   </div> */}
        {/* )} */}

        <div className="build">Build: {this.props.build}</div>
      </div>
    );
  }
}

Start.defaultProps = {
  loading: false,
  appCode: 'app',
  appName: 'Application',
  studentAlias: '',
  hasWebGL: true,
  build: 'DEV',
};

Start.propTypes = {
  loading: PropTypes.bool,
  appCode: PropTypes.string,
  appName: PropTypes.string,
  studentAlias: PropTypes.string,
  hasWebGL: PropTypes.bool,
  build: PropTypes.string,
  unityMode: PropTypes.oneOf([UNITY_MODE_CONSOLE, UNITY_MODE_WEBGL]),
};
